/* EVCARS skin: interactions for the ev-* sections. Builds on window.EV from ev-core.js
   (saved vehicle, visitor country, filter URLs, related products). */
(() => {
  const EV = window.EV;
  if (!EV) return;
  const T = window.EV_T || {};
  const CFG = window.EV_CFG || {};
  const root = CFG.root && CFG.root !== '/' ? CFG.root.replace(/\/$/, '') + '/' : '/';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k, d, s = localStorage) { try { const v = s.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v, s = localStorage) { try { s.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  const vehicles = () => EV.vehicles().filter((v) => !v.universal);
  const byHandle = (h) => EV.vehicles().find((v) => v.handle === h);
  const gidOf = (id) => (String(id).startsWith('gid://') ? String(id) : 'gid://shopify/Metaobject/' + id);

  /* ---------- Garage: several saved cars, the active one is EV.get() ---------- */
  const garage = {
    list() { return store.get('ev_garage', []).filter((h) => byHandle(h)); },
    add(h) { const l = garage.list().filter((x) => x !== h); l.unshift(h); store.set('ev_garage', l); },
    remove(h) {
      store.set('ev_garage', garage.list().filter((x) => x !== h));
      const a = EV.get();
      if (a && a.handle === h) { const next = byHandle(garage.list()[0]); EV.set(next || null); }
    },
  };
  const choose = (v) => { garage.add(v.handle); EV.set(v); };
  const active = () => EV.get();
  // A car saved before the garage existed still counts as saved.
  if (active() && !garage.list().includes(active().handle)) garage.add(active().handle);
  document.addEventListener('ev:vehicle', (e) => { if (e.detail) garage.add(e.detail.handle); paint(); });

  /* ---------- Panels: menu drawer, search and sort sheets ---------- */
  const open = (name) => {
    const p = $(`[data-evx-panel="${name}"]`);
    if (!p) return;
    p.classList.add('evx-open');
    document.documentElement.style.overflow = 'hidden';
    const f = $('[data-evx-autofocus]', p);
    if (f) setTimeout(() => f.focus(), 50);
  };
  const closeAll = () => { $$('[data-evx-panel].evx-open').forEach((p) => p.classList.remove('evx-open')); document.documentElement.style.overflow = ''; };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-evx-open]');
    if (o) { e.preventDefault(); open(o.dataset.evxOpen); }
    if (e.target.closest('[data-evx-close]')) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Toast + cart count ---------- */
  let toastT;
  function toast(msg) {
    const el = $('[data-evx-toast]');
    if (!el) return;
    $('[data-evx-toast-t]', el).textContent = msg.length > 42 ? msg.slice(0, 40) + '…' : msg;
    el.classList.add('evx-show');
    clearTimeout(toastT);
    toastT = setTimeout(() => el.classList.remove('evx-show'), 2800);
  }
  function setCount(n) { $$('[data-evx-count]').forEach((b) => { b.textContent = n; b.hidden = !n; }); }
  function refreshCount() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {}); }
  function addToCart(body) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body }).then(async (r) => {
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'Error');
      refreshCount();
      if (window.EV && EV.syncCar) EV.syncCar();
      return d;
    });
  }

  /* Card quick add */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-evx-add]');
    if (!f) return;
    e.preventDefault();
    const btn = $('button', f);
    if (!btn || btn.disabled) return;
    const html = btn.innerHTML;
    btn.classList.add('evx-busy');
    addToCart(new FormData(f))
      .then((item) => {
        btn.classList.remove('evx-busy');
        btn.classList.add('evx-done');
        btn.textContent = '✓ ' + (T.added || '');
        toast(item.product_title || item.title || '');
        setTimeout(() => { btn.classList.remove('evx-done'); btn.innerHTML = html; }, 1800);
      })
      .catch((err) => { btn.classList.remove('evx-busy'); toast(err.message); });
  });

  /* ---------- "Fits your car" badges, car tiles, shipping rows ---------- */
  function paint() {
    const a = active();
    $$('.evx-card[data-veh]').forEach((c) => {
      const l = (c.dataset.veh || '').split(',').filter(Boolean);
      const fit = !!a && (l.includes(a.handle) || (c.dataset.universal === 'true'));
      const b = $('[data-ev-badge]', c);
      if (b) b.hidden = !fit;
    });
    $$('[data-ev-pick]').forEach((el) => {
      const v = byHandle(el.dataset.evPick);
      if (!v) return;
      if (el.tagName === 'A') el.href = EV.carUrl(v, CFG.allUrl);
      const mine = !!a && a.handle === v.handle;
      el.classList.toggle('evx-is-mine', mine);
      const m = $('[data-ev-mine]', el);
      if (m) m.hidden = !mine;
    });
    $$('[data-evx-fit-label]').forEach((el) => { if (a && el.textContent !== a.label) el.textContent = a.label; });
    paintShipping();
  }
  function paintShipping() {
    const c = EV.country();
    $$('.evx-ship-table [data-ev-countries]').forEach((r) => r.classList.toggle('evx-me', r.dataset.evCountries.includes(',' + c + ',')));
  }
  document.addEventListener('ev:country', paintShipping);
  document.addEventListener('click', (e) => {
    const p = e.target.closest('[data-ev-pick]');
    if (!p) return;
    const v = byHandle(p.dataset.evPick);
    if (v) choose(v);
  });
  new MutationObserver(() => { clearTimeout(paint.t); paint.t = setTimeout(paint, 30); }).observe(document.body, { childList: true, subtree: true });

  /* ---------- Finder: make -> model -> year ---------- */
  function bindFinder(box) {
    const sm = $('[data-s="make"]', box), so = $('[data-s="model"]', box), sy = $('[data-s="year"]', box), go = $('[data-go]', box);
    const list = vehicles();
    const opt = (v, l) => { const o = document.createElement('option'); o.value = v; o.textContent = l; return o; };
    const fill = (s, first, items) => { s.replaceChildren(opt('', first), ...items.map(([v, l]) => opt(v, l))); };
    fill(sm, T.pickMake, [...new Set(list.map((v) => v.make))].map((m) => [m, m]));
    const reset = (s, l) => { fill(s, l, []); s.disabled = true; };
    reset(so, T.pickModel); reset(sy, T.pickYear); go.disabled = true;
    sm.onchange = () => {
      const models = [...new Set(list.filter((v) => v.make === sm.value).map((v) => v.model))];
      fill(so, T.pickModel, models.map((m) => [m, m])); so.disabled = !sm.value;
      reset(sy, T.pickYear); go.disabled = true;
      if (models.length === 1) { so.value = models[0]; so.onchange(); }
    };
    so.onchange = () => {
      const ys = list.filter((v) => v.make === sm.value && v.model === so.value);
      fill(sy, T.pickYear, ys.map((v) => [v.handle, v.years || T.allYears])); sy.disabled = !so.value;
      go.disabled = true;
      if (ys.length === 1) { sy.value = ys[0].handle; go.disabled = false; }
    };
    sy.onchange = () => { go.disabled = !sy.value; };
    go.onclick = () => {
      const v = byHandle(sy.value);
      if (!v) return;
      choose(v);
      location.assign(EV.carUrl(v, CFG.allUrl));
    };
    const saved = $('[data-evx-saved]', box);
    if (saved) {
      const l = garage.list();
      saved.hidden = !l.length;
      const a = active();
      l.forEach((h) => {
        const v = byHandle(h);
        const c = document.createElement('a');
        c.className = 'evx-chip' + (a && a.handle === h ? ' evx-on' : '');
        c.dataset.evPick = h;
        c.textContent = v.label;
        saved.append(c);
      });
    }
  }
  $$('[data-evx-finder]').forEach(bindFinder);

  /* ---------- Garage page list ---------- */
  const glist = $('[data-evx-garage-list]');
  function drawGarage() {
    if (!glist) return;
    const a = active();
    const l = garage.list();
    if (!l.length) { glist.innerHTML = `<p class="evx-note">${T.noCars || ''}</p>`; return; }
    glist.replaceChildren(...l.map((h) => {
      const v = byHandle(h);
      const on = a && a.handle === h;
      const row = document.createElement('div');
      row.className = 'evx-gcar' + (on ? ' evx-on' : '');
      row.innerHTML = `<img alt="" loading="lazy"><div><b></b><span></span></div><div class="evx-gcar-act"></div>`;
      const img = $('img', row); img.src = v.img; img.onerror = () => (img.style.visibility = 'hidden');
      $('b', row).textContent = v.label;
      const sub = $('span', row);
      if (on) sub.textContent = T.active;
      else { sub.dataset.evCount = h; }
      const act = $('.evx-gcar-act', row);
      const show = document.createElement('a');
      show.className = 'evx-chip'; show.textContent = on ? '→' : T.setActive; show.href = EV.carUrl(v, CFG.allUrl); show.dataset.evPick = h;
      const rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'evx-icon-btn'; rm.setAttribute('aria-label', T.remove); rm.textContent = '×'; rm.style.fontSize = '22px';
      rm.onclick = () => { garage.remove(h); drawGarage(); };
      act.append(show, rm);
      return row;
    }));
    fillCounts();
  }
  drawGarage();
  document.addEventListener('ev:vehicle', drawGarage);

  /* ---------- Counts per car / category (one request per session) ---------- */
  let countsP;
  function counts() {
    if (!countsP) {
      const cached = store.get('ev_counts', null, sessionStorage);
      countsP = cached && Date.now() - cached.t < 6e5
        ? Promise.resolve(cached.d)
        : fetch((CFG.allUrl || '/collections/all') + '?section_id=ev-counts')
            .then((r) => r.text())
            .then((html) => {
              const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ev-counts]');
              const d = el ? JSON.parse(el.textContent) : null;
              if (d) store.set('ev_counts', { t: Date.now(), d }, sessionStorage);
              return d;
            })
            .catch(() => null);
    }
    return countsP;
  }
  function fillCounts() {
    const need = $$('[data-ev-count], [data-ev-cat-count]');
    if (!need.length) return;
    counts().then((d) => {
      if (!d) return;
      const vf = d.filters['filter.p.m.custom.compatible_vehicles'] || [];
      const cf = d.filters['filter.p.m.custom.ev_category'] || [];
      $$('[data-ev-count]').forEach((el) => {
        const v = byHandle(el.dataset.evCount);
        const hit = v && vf.find((x) => x.value === gidOf(v.id) || x.label === v.label);
        if (hit) el.textContent = el.tagName === 'SPAN' && el.closest('.evx-gcar') ? `${hit.count} ${T.products}` : hit.count;
      });
      $$('[data-ev-cat-count]').forEach((el) => {
        const hit = cf.find((x) => x.value === el.dataset.evCatCount);
        if (hit) el.textContent = `(${hit.count})`;
      });
    });
  }
  fillCounts();

  /* ---------- Home picks for the saved car ---------- */
  const picks = $('[data-evx-picks]');
  if (picks && active()) {
    const a = active();
    const url = EV.filterUrl(picks.dataset.collectionUrl, a);
    const l2 = $('[data-evx-picks-l2]', picks);
    fetch(url + '&section_id=ev-related')
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = [...doc.querySelectorAll('[data-ev-item]')].slice(0, +picks.dataset.limit || 8);
        if (!items.length) return;
        $('[data-evx-picks-grid]', picks).replaceChildren(...items);
        if (l2) l2.textContent = l2.dataset.evxPicksL2;
        $('[data-evx-picks-all]', picks).href = url;
      })
      .catch(() => {});
  }

  /* ---------- Collection: sort + load more ---------- */
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-evx-sort]');
    if (s) {
      e.preventDefault();
      const u = new URL(location.href);
      u.searchParams.set('sort_by', s.dataset.evxSort);
      u.searchParams.delete('page');
      location.assign(u.pathname + u.search);
    }
    const more = e.target.closest('[data-evx-more]');
    if (more) {
      e.preventDefault();
      more.classList.add('evx-busy');
      fetch(more.href)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = $('[data-evx-grid]');
          grid.append(...doc.querySelectorAll('[data-evx-grid] > *'));
          const next = doc.querySelector('[data-evx-more]');
          if (next) { more.href = next.href; more.classList.remove('evx-busy'); } else more.closest('.evx-more').remove();
        })
        .catch(() => { location.assign(more.href); });
    }
  });

  /* ---------- Product page ---------- */
  const pdp = $('[data-evx-product]');
  if (pdp) {
    const form = $('[data-evx-product-form]', pdp);
    const variants = JSON.parse(($('[data-evx-variants]', pdp) || {}).textContent || '[]');
    const idInput = $('[data-evx-variant-id]', pdp);
    const addBtn = $('[data-evx-add-btn]', pdp);
    const nowBtn = $('[data-evx-buy-now]', pdp);
    const stickyBtn = $('[data-evx-sticky-add]', pdp);
    const mainImg = $('.evx-gallery-main img', pdp);
    const label = addBtn ? addBtn.textContent.trim() : '';
    let qty = 1;

    pdp.addEventListener('click', (e) => {
      const th = e.target.closest('[data-evx-src]');
      if (th && mainImg) {
        mainImg.srcset = ''; mainImg.src = th.dataset.evxSrc;
        $$('.evx-thumbs button', pdp).forEach((b) => b.classList.toggle('evx-on', b === th));
      }
      const q = e.target.closest('[data-evx-q]');
      if (q) { qty = Math.max(1, qty + +q.dataset.evxQ); $('[data-evx-qv]', pdp).textContent = qty; $('[data-evx-qty]', pdp).value = qty; }
      const ob = e.target.closest('[data-evx-option] button');
      if (ob) {
        $$('button', ob.parentElement).forEach((b) => b.classList.toggle('evx-on', b === ob));
        const sel = $$('[data-evx-option]', pdp).map((g) => ($('.evx-on', g) || {}).dataset?.value);
        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        setVariant(v);
      }
    });
    function setVariant(v) {
      const ok = !!(v && v.available);
      [addBtn, nowBtn, stickyBtn].forEach((b) => b && (b.disabled = !ok));
      if (addBtn) addBtn.textContent = ok ? label : (T.soldOut || '—');
      if (!v) return;
      idInput.value = v.id;
      $$('[data-evx-price]', pdp).forEach((el) => (el.textContent = v.price));
      $('[data-evx-compare]', pdp).textContent = v.compare;
      const sp = $('[data-evx-split]', pdp); if (sp) sp.textContent = v.split;
      if (v.img && mainImg) { mainImg.srcset = ''; mainImg.src = v.img; }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('evx-busy');
        addToCart(new FormData(form))
          .then((item) => { toast(item.product_title || ''); })
          .catch((err) => toast(err.message))
          .finally(() => addBtn.classList.remove('evx-busy'));
      });
    }
    if (nowBtn) nowBtn.addEventListener('click', () => {
      nowBtn.classList.add('evx-busy');
      addToCart(new FormData(form)).then(() => location.assign(root + 'checkout')).catch((err) => { nowBtn.classList.remove('evx-busy'); toast(err.message); });
    });
    if (stickyBtn) stickyBtn.addEventListener('click', () => form.requestSubmit());
    const anchor = $('[data-evx-buy-anchor]', pdp), sticky = $('[data-evx-sticky]', pdp);
    if (anchor && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('evx-show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(anchor);
    }

    /* Specs read from the title until the supplier spec sheet fills metafields */
    const sp = $('[data-evx-specs]', pdp);
    if (sp) {
      const t = sp.dataset.title || '';
      const kw = (t.match(/(\d+(?:\.\d+)?)\s?kw/i) || [])[1];
      const amp = (t.match(/(\d+)\s?A\b/) || [])[1];
      const conn = /gb\/?t/i.test(t) ? 'GB/T' : /type ?2/i.test(t) ? 'Type 2' : /usa|nacs/i.test(t) ? 'NACS' : /ccs/i.test(t) ? 'CCS' : '';
      const w = sp.dataset.warranty;
      const tiles = [
        kw && ['M13 2 4 14h7l-1 8 9-12h-7z', kw, 'kW', T.power, 100],
        amp && ['M13 2 4 14h7l-1 8 9-12h-7z', amp, 'A', T.amps, 70],
        conn && ['M9 2v5M15 2v5M6 7h12v4a6 6 0 0 1-12 0zM12 17v5', conn, '', T.connector, 60],
        w && ['M12 3 5 6v6c0 4 3 7.5 7 9 4-1.5 7-5 7-9V6z', w === '2' ? sp.dataset.w2 : sp.dataset.w1, '', sp.dataset.wLabel, 85],
      ].filter(Boolean);
      if (tiles.length > 1) {
        const box = $('.evx-specs', sp);
        tiles.forEach(([d, v, u, k, pct]) => {
          const el = document.createElement('div');
          el.className = 'evx-spec';
          el.innerHTML = `<svg class="evx-ico evx-ico-s" viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg><div class="evx-v"></div><div class="evx-k"></div><div class="evx-bar"><i style="width:${pct}%"></i></div>`;
          $('.evx-v', el).textContent = v;
          if (u) { const s = document.createElement('small'); s.textContent = u; $('.evx-v', el).append(s); }
          $('.evx-k', el).textContent = k;
          box.append(el);
        });
        sp.hidden = false;
      }
    }
  }

  /* ---------- Cart page quantities ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-evx-line]');
    if (!b) return;
    b.closest('.evx-line').classList.add('evx-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.evxLine, quantity: Math.max(0, +b.dataset.evxQtyTo) }),
    }).finally(() => location.reload());
  });

  paint();
})();
